import React, { FC } from 'react';
import { Account } from '@johnlewispartnership/wtr-style-dictionary/icons/react/Account';
import { TextLink } from '@johnlewispartnership/wtr-ingredients/ingredients/TextLink/index.js';
import { handleLoginWithRedirect } from 'utils/login';
import { urls } from 'constants/urls';

import styles from './SignIn.module.scss';

type SignInProps = {
  className: string;
  loggedIn: boolean;
};

export const SignIn: FC<SignInProps> = ({ className, loggedIn }) =>
  !loggedIn ? (
    <>
      <TextLink
        className={className}
        href={urls.login}
        onClick={handleLoginWithRedirect}
        underline="never"
      >
        <Account className={styles.signInIcon} />
        Sign in
      </TextLink>
      <TextLink className={className} href={urls.registration} underline="never">
        Register
      </TextLink>
    </>
  ) : null;
